var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteSendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:send-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2423 7.75618L7.27359 11.3606L10.5946 13.2828L13.523 10.3536C13.6716 10.2052 13.873 10.1218 14.083 10.1219C14.293 10.122 14.4944 10.2055 14.6428 10.354C14.7913 10.5026 14.8746 10.704 14.8745 10.914C14.8745 11.124 14.791 11.3254 14.6424 11.4738L11.7133 14.403L13.637 17.7233L17.2423 7.75618ZM17.498 5.97968C18.444 5.63689 19.3608 6.55364 19.018 7.49968L14.8364 19.062C14.4928 20.0104 13.1976 20.126 12.6918 19.2528L10.145 14.8527L5.74488 12.3059C4.87167 11.8 4.98725 10.5048 5.93567 10.1613L17.498 5.97968Z",
    fill: "#010048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteSendLine);
export default __webpack_public_path__ + "static/media/mingcute_send-line.e51e86b5bfc60416774fe51bdc507ebc.svg";
export { ForwardRef as ReactComponent };